import React from 'react';
import { useAppSelector } from 'app/hooks';
import { getSelectedMapLayer } from './selectors';
import ZoneGenerationYieldContent from './ZoneGenerationYieldContent';
import ZoneGenerationCciContent from './ZoneGenerationCciContent';

const ZoneGenerationLayersTypeContent = () => {
  const { selectedMapType } = useAppSelector(getSelectedMapLayer);

  const Content = {
    cci: ZoneGenerationCciContent,
    yield: ZoneGenerationYieldContent
  }[selectedMapType];

  if (!selectedMapType || !Content) {
    return null;
  }

  return <Content />;
};

export default ZoneGenerationLayersTypeContent;